import { EAvatar, EIcon } from 'common/enum/misc.enum';

export const COLOR_WHITE = '#FFFFFF';
export const COLOR_PRIMARY = '#14004D';
export const COLOR_GREY = '#988FB2';
export const COLOR_DIVIDER = '#DCDAE5';
export const COLOR_TINT = '#5C2EE5';
export const COLOR_WARNING = '#FA7E25';
export const COLOR_SUCCESS = '#12B27D';
export const COLOR_ERROR = '#FA3C32';

export const SCHOOL_SUBJECT_COLORS = [
  COLOR_PRIMARY, // primary
  COLOR_GREY, // secondary
  '#DCDAE5', // gray-300
  '#99664D', // chocolate
  '#E5A15C', // nougat
  '#F2BA00', // banana
  '#FA9E00', // mandarine
  COLOR_WARNING, // orange
  '#F25824', // papaya
  COLOR_ERROR, // red
  '#E53973', // cranberry
  '#D92BBC', // orchid
  COLOR_TINT, // grape/tint
  '#0C59F2', // ocean
  '#00BDFC', // sky
  '#14C7B8', // jade
  COLOR_SUCCESS, // moss
  '#66BF39', // grass
];
export const DEFAULT_SCHOOL_SUBJECT_COLOR = SCHOOL_SUBJECT_COLORS[5];

export const PERFORMANCE_LEVEL_RATING_COLORS = [
  COLOR_ERROR, // red
  COLOR_WARNING, // orange
  '#FAC700', // yellow
  COLOR_SUCCESS, // green
];

export const STUDENT_AVATAR_OPTIONS: EAvatar[] = [
  EAvatar.AVATAR_1,
  EAvatar.AVATAR_2,
  EAvatar.AVATAR_3,
  EAvatar.AVATAR_4,
  EAvatar.AVATAR_5,
  EAvatar.AVATAR_6,
  EAvatar.AVATAR_7,
  EAvatar.AVATAR_8,
  EAvatar.AVATAR_9,
  EAvatar.AVATAR_10,
  EAvatar.AVATAR_11,
  EAvatar.AVATAR_12,
];

export const TEACHER_AVATAR_OPTIONS: EAvatar[] = [
  EAvatar.AVATAR_13,
  EAvatar.AVATAR_14,
  EAvatar.AVATAR_15,
  EAvatar.AVATAR_16,
  EAvatar.AVATAR_17,
  EAvatar.AVATAR_18,
  EAvatar.AVATAR_19,
  EAvatar.AVATAR_20,
  EAvatar.AVATAR_21,
  EAvatar.AVATAR_22,
  EAvatar.AVATAR_23,
  EAvatar.AVATAR_24,
];

export const STUDENT_AVATAR_ICON_OPTIONS: EIcon[] = [EIcon.BOY, EIcon.GIRL];
